import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

const DashboardAdmin = Loadable(lazy(() => import("views/admin/dashboard")));
const ChallanListing = Loadable(
  lazy(() => import("views/admin/challan-listing"))
);

const AdminRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/admin/dashboard",
      element: <DashboardAdmin />,
    },
    {
      path: "/admin/challan-listing/:id",
      element: <ChallanListing />,
    },
  ],
};

export default AdminRoutes;
